import I18n from 'i18n-js';
import en from './en.json';

window.I18n = {};

I18n.defaultLocale = 'en_AU';
I18n.translations = {
  en,
  en_AU: en,
  'en-CA': en,
  en_CA: en,
};

export function _(name, params = {}) {
  return I18n.t(name, params);
}

export default I18n;
